import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IIpAllowListApiResult } from '../types/IpAllowList';

/**
 * Parameters for deleting the IP allowlist
 */
export interface IDeleteIpAllowListParams {
}

/**
 * Result containing the deletion status
 */
export interface IDeleteIpAllowListResult extends IIpAllowListApiResult {
}

/**
 * Request class for deleting the IP allowlist configuration
 * @example
 * const request = new DeleteIpAllowListRequest();
 * const result = await WebHttpClient.sendRequest(request);
 */
export class DeleteIpAllowListRequest extends Request<IDeleteIpAllowListParams, IDeleteIpAllowListResult> {
  constructor(params: IDeleteIpAllowListParams = {}) {
    super('deleteIpAllowList', params);
  }
}